
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13.405","height":"16","viewBox":"0 0 13.405 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.027 15.999a2.375 2.375 0 01-2.162-3.361l-4.7-3.074a2.375 2.375 0 11.007-3.122l4.7-3.074a2.331 2.331 0 01-.223-.986 2.387 2.387 0 11.716 1.7L4.608 7.19a2.37 2.37 0 01.149.817 2.336 2.336 0 01-.149.818l4.75 3.108a2.379 2.379 0 111.669 4.074zm0-.865a1.514 1.514 0 10-1.514-1.514 1.507 1.507 0 001.514 1.518zM2.378 9.512A1.514 1.514 0 10.864 7.998a1.507 1.507 0 001.514 1.515zm8.649-5.622a1.513 1.513 0 10-1.514-1.513 1.507 1.507 0 001.514 1.514z","fill":"#fc8308"}})])
          )
        }
      }
    